export default __webpack_public_path__ + "static/media/rightEllipse.a61971de.png";